export default __webpack_public_path__ + "static/media/i196jk.8308f7a5.webp";